import Cookies from 'js-cookie'
import ShopCore from 'shop-js'

const dataCore = {
  environment: process.env.VUE_APP_CORE_ENV,
  theme: process.env.VUE_APP_THEME
}

const ShopInstance = new ShopCore(dataCore)
const envAcronym = ShopInstance.envAcronym

export const setCookieShop = (data = {}) => {
  const cookieData = Cookies.get(`${envAcronym}mp_shop`)

  if (cookieData) {
    Promise.resolve(atob(cookieData)).then(JSON.parse).then(resCookieParse => {
      Cookies.set(`${envAcronym}mp_shop`, btoa(JSON.stringify({ ...resCookieParse, ...data })), { expires: 0.5 })
    })
  } else {
    Cookies.set(`${envAcronym}mp_shop`, btoa(JSON.stringify({ ...data })), { expires: 0.5 })
  }
}

export const updateCookieShop = (key, data = {}) => {
  const cookieData = Cookies.get(`${envAcronym}mp_shop`)
  if (cookieData) {
    Promise.resolve(atob(cookieData)).then(JSON.parse).then(resCookieParse => {
      delete resCookieParse[key]
      if (Object.entries(resCookieParse).length || Object.entries(data).length) {
        Cookies.set(`${envAcronym}mp_shop`, btoa(JSON.stringify({ ...data })), { expires: 0.5 })
      } else {
        Cookies.remove(`${envAcronym}mp_shop`)
      }
    })
  }
}
